<template>
  <div class="usage-terms-personalize-form-preview">
    <login-personalize-preview-main :config="config"
                                    class="usage-terms-personalize-form-preview-main" 
                                    :temporary-image="temporaryImage"
                                    :temporary-logo="temporaryLogo"/>

    <login-personalize-preview-login :config="config" 
                                     :temporary-image="temporaryImage"
                                     :temporary-logo="temporaryLogo"/>

    <login-personalize-preview-term :config="config" 
                                    :temporary-image="temporaryImage"/>

    <login-personalize-preview-panel v-model="config" 
                                     @set-temporary-image="setTemporaryImage"
                                     @set-temporary-logo="setTemporaryLogo"/>

  </div>
</template>

<script>
import LoginPersonalizePreviewMain from "@components/modules/login-personalize/preview/main/LoginPersonalizePreviewMain.vue";
import LoginPersonalizePreviewLogin from "@components/modules/login-personalize/preview/login/LoginPersonalizePreviewLogin.vue";
import LoginPersonalizePreviewTerm from "@components/modules/login-personalize/preview/term/LoginPersonalizePreviewTerm.vue";
import LoginPersonalizePreviewPanel from "@components/modules/login-personalize/preview/panel/LoginPersonalizePreviewPanel.vue";

export default {
  components: {
    LoginPersonalizePreviewMain,
    LoginPersonalizePreviewTerm,
    LoginPersonalizePreviewPanel,
    LoginPersonalizePreviewLogin,
  },

  data() {
    return {
      config: {
        ...this.initialConfig,
      },
      temporaryImage: undefined,
      temporaryLogo: undefined
    };
  },

  props: {
    initialConfig: {
      type: Object,
    },
  },

  computed: {},

  methods: {
    setTemporaryImage(base64Img) {     
      this.temporaryImage = base64Img;      
    },
    setTemporaryLogo(base64Logo) {
      this.temporaryLogo = base64Logo
    }
  },

  mounted() {},

  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.usage-terms-personalize-form-preview {
  display: flex;

  > * {
    margin-right: 50px;
  }
}
</style>
